import { UrlOutput } from 'services/device/domain/business/common/Output';
import { LabelRenderer } from 'services/device/presentation/ui/widget/label-renderer/LabelRenderer';
import { UrlOutputValueRenderer } from 'services/device/presentation/ui/widget/output-value-renderer/UrlOutputValueRenderer';

export interface UrlOutputProps {
	output: UrlOutput;
}

export const UrlOutputRenderer = (props: UrlOutputProps): JSX.Element => {
	const { output } = props;

	return (
		<li key={output.getName()}>
			<strong>
				<LabelRenderer output={output} />
			</strong>
			<p>
				<UrlOutputValueRenderer output={output} />
			</p>
		</li>
	);

};
